import base64 from 'base-64'
import utf8 from 'utf8'

const encode = value => base64.encode(utf8.encode(value))
const decode = value => utf8.decode(base64.decode(value))

const key = base64.encode(utf8.encode('mpToken-v2'))

export default {
  get token(): string {
    const token = sessionStorage.getItem(key) || ''

    return decode(token)
  },

  get header() {
    return {
      Authorization: `Bearer ${this.token}`
    }
  },

  updateToken(tokenRaw: string): void {
    sessionStorage.setItem(key, encode(tokenRaw))
  },

  removeToken(): void {
    sessionStorage.removeItem(key)
  },
}
